module.exports = __webpack_public_path__ + "img/notifica-libro.9d0b572d.svg";